// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1266":"fe2b6c01","9691":"fe2b6c01"}[chunkId] + ".chunk.css";
};